/**
 * @typedef {import('../apis/hey-api/types.gen').UserPreferenceOptionDto} UserPreferenceOptionDto
 */

/** @type {UserPreferenceOptionDto} */
export const DEFAULT_USER_PREFERENCE_OPTION = {
  temperatureUnit: 'celsius',
  windSpeedUnit: 'mps',
  weightUnit: 'kg',
  waterUnit: 'L',
  language: 'en-US',
};

export const TEMPERATURE_UNIT_OPTIONS = [
  { label: '°C', value: 'celsius' },
  { label: '°F', value: 'fahrenheit' },
];

export const WIND_SPEED_UNIT_OPTIONS = [
  { label: 'm/s', value: 'mps' },
  { label: 'ft/s', value: 'ftps' },
];

export const WEIGHT_UNIT_OPTIONS = [
  { label: 'kg', value: 'kg' },
  { label: 'lbs', value: 'lbs' },
];

export const WATER_UNIT_OPTIONS = [
  { label: 'L', value: 'L' },
  { label: 'gal', value: 'gal' },
];

export const USER_PREFERENCE_LANGUAGE_OPTIONS = [
  { label: 'English (United States) [en-US]', value: 'en-US' },
  { label: 'Chinese (Taiwan) [zh-TW]', value: 'zh-TW' },
  { label: 'Spanish [es]', value: 'es' },
  { label: 'Ukrainian [uk]', value: 'uk' },
  { label: 'Hebrew [he]', value: 'he' },
];
